import { api } from './axios';
import type { SuperAdminDashboard, Unit, User } from '../types/domain';

export interface CreateUnitDto {
  name: string;
  slug: string;
}

export interface UpdateUnitDto {
  name: string;
  slug: string;
  isActive?: boolean;
  /** Pokud true, admin jednotky muze v nastaveni soutezi vypnout zobrazeni na rozcestniku. */
  canHideFromLanding?: boolean;
}

export interface CreateUserDto {
  username: string;
  password: string;
  email?: string;
  displayName: string;
  role: 'SUPER_ADMIN' | 'UNIT_ADMIN' | 'RECORDER';
  unitId?: number | null;
}

export interface UpdateUserDto {
  displayName: string;
  email?: string;
  role: 'SUPER_ADMIN' | 'UNIT_ADMIN' | 'RECORDER';
  isActive?: boolean;
  unitId?: number | null;
}

export const superAdminApi = {
  // Dashboard
  dashboard: () => api.get<SuperAdminDashboard>('/superadmin/dashboard').then((r) => r.data),

  // Units
  listUnits: () => api.get<Unit[]>('/superadmin/units').then((r) => r.data),
  createUnit: (dto: CreateUnitDto) => api.post<Unit>('/superadmin/units', dto).then((r) => r.data),
  updateUnit: (id: number, dto: UpdateUnitDto) =>
    api.put<Unit>(`/superadmin/units/${id}`, dto).then((r) => r.data),
  deactivateUnit: (id: number) => api.delete(`/superadmin/units/${id}`),

  // Users
  listUsers: () => api.get<User[]>('/superadmin/users').then((r) => r.data),
  listUsersByUnit: (unitId: number) =>
    api.get<User[]>(`/superadmin/units/${unitId}/users`).then((r) => r.data),
  createUser: (dto: CreateUserDto) => api.post<User>('/superadmin/users', dto).then((r) => r.data),
  updateUser: (id: number, dto: UpdateUserDto) =>
    api.put<User>(`/superadmin/users/${id}`, dto).then((r) => r.data),
  resetUserPassword: (id: number, newPassword: string) =>
    api.post(`/superadmin/users/${id}/reset-password`, { newPassword }),
  deactivateUser: (id: number) => api.delete(`/superadmin/users/${id}`),

  // Competitions (cross-unit)
  liveCompetitions: () =>
    api.get<SuperAdminDashboard>('/superadmin/dashboard').then((r) => r.data.liveList),
};
